"use strict";

exports.__esModule = true;
exports.requestFileDownloadUrl = exports.requestFileUploadUrl = exports.requestCredentials = void 0;

var requestCredentials = function requestCredentials(request, type) {
  return request("/_api/media/credentials/" + type);
};

exports.requestCredentials = requestCredentials;

var requestFileUploadUrl = function requestFileUploadUrl(request, fileName, mimeType) {
  return request.post('/v2/files/upload-url', {
    fileName: fileName,
    mimeType: mimeType
  }, {
    retry: 2
  });
};

exports.requestFileUploadUrl = requestFileUploadUrl;

var requestFileDownloadUrl = function requestFileDownloadUrl(request, postId, filePath) {
  return request.post('/v2/files/download-url', {
    postId: postId,
    filePath: filePath
  });
};

exports.requestFileDownloadUrl = requestFileDownloadUrl;